import { DOCUMENT } from "@angular/common";
import { Component, Inject, OnInit } from "@angular/core";
import { SeoService } from "src/app/services/seo/seo.service";
import { PATHS, ROUTES } from "src/constants";

@Component({
  selector: "app-nearshoring-de",
  templateUrl: "./nearshoring-de.component.html",
  styleUrls: ["./nearshoring-de.component.scss"],
})
export class NearshoringDeComponent implements OnInit {
  public ROUTES = ROUTES;
  public PATHS = PATHS;

  constructor(@Inject("isBrowser") private isBrowser: boolean, @Inject(DOCUMENT) private document: Document, private seo: SeoService) {}

  ngOnInit() {
    this.seo.updateMeta({
      title: "Coara - Nearshoring & Development Teams in Europe",
      description:
        "Coara offers nearshoring excellence with European development teams. Use our Build-Operate-Transfer model for your own team in Estonia or Spain.",
      imageUrl: "https://coara.co/assets/images/sharing/facebook.jpg",
    });
    this.seo.setCanonicalURL();
  }
}
